import * as React from 'react';

export * from './components'
export * from './layouts'
export * from './widgets'

const DOUBLE_TAP_INTERVAL = 400

export const onTouchDoubleTap = (cb) => {
  let lastTouchEvent: number | null = null

  return (e: React.TouchEvent) => {
    const now = Date.now()

    //e.stopPropagation()
    //e.preventDefault()

    //console.log(e.currentTarget, `onTouchDoubleTap`, e, now, lastTouchEvent)

    if (lastTouchEvent !== null) {
      const interval = now - lastTouchEvent
      //console.log(interval)
      if (interval <= DOUBLE_TAP_INTERVAL) {
        //console.log(`Calling onTouchDoubleTap()`, interval)
        lastTouchEvent = null
        cb && cb(e)
        return
      }
    }
    lastTouchEvent = now
  }
}


// WEBPACK FOOTER //
// ./src/shared/components/ui/ui.tsx